/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react'
import {KTFilterButton} from './KTFilterButton'
import {KTDateRangeFilter} from './KTDateRangeFilter'
import {IFormField} from 'models/Common'
import {Modal} from 'react-bootstrap'
import GenericFilters from './GenericFilters'
import {Model} from './Modal'
import {useTranslation} from 'react-i18next'
interface Props {
 dateRangeContainerClass?: string | undefined
 dateRangeTitleClass?: string | undefined
 dateRangeTitle?: string | undefined
 dateRangeBtnClass?: string | undefined
 icon?: React.ReactNode
 btnText?: string
 containerClass?: string
 btnClass?: string
 showDateRangeBox?: boolean
 type?: 'button' | 'submit' | 'reset' | undefined
 disabled?: boolean
 children?: React.ReactNode
 filterConfig: IFormField
 setFilterFormData: (formData: IFormField) => void
 filterFormData: IFormField | null
 parentId?: string
 filterCount: number
 setLoader: (newState: boolean) => void
}
const KTFilterBox = (props: Props) => {
 const {t} = useTranslation()
 const [isFilterOpen, setIsFilterOpen] = useState(false)

 const applyFilter = async () => {
  setIsFilterOpen(false)
 }

 return (
  <>
   <Model
    show={true}
    showHeader={false}
    modelWrapperClass={isFilterOpen ? 'block' : 'hidden'}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     setIsFilterOpen(false)
    }}
    modelClass='w-[752px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {t('common.filter')}
      </p>
      <GenericFilters
       parentId={props.parentId}
       filterConfig={props.filterConfig}
       filterNav={[]}
       dropdown={[]}
       formData={props.filterFormData}
       applyFilter={applyFilter}
       setFormData={props.setFilterFormData}
       setLoader={props.setLoader}
      />
     </div>
    </div>
   </Model>
   <div
    className={`${props?.containerClass} flex items-center text-[#171B1F] bg-[#F5F8FA] text-xl font-bold rounded-lg p-2 mb-6`}
   >
    <KTFilterButton
     filterCount={props?.filterCount}
     containerClass={props?.btnClass}
     text={props.btnText}
     onClick={() => {
      setIsFilterOpen(true)
     }}
    />
    {props?.showDateRangeBox && (
     <KTDateRangeFilter
      containerClass={props.dateRangeContainerClass}
      titleClass={props.dateRangeTitleClass}
      title={props.dateRangeTitle}
      btnClass={props.dateRangeBtnClass}
      filterFormData={{
       rangeType: 7,
       ...props.filterFormData,
      }}
      setFilterFormData={props.setFilterFormData}
     />
    )}
    {props?.children && props?.children}
   </div>
  </>
 )
}

KTFilterBox.defaultProps = {
 className: 'w-full',
}

export {KTFilterBox}
